import * as Sentry from '@sentry/react'
import { ModuleMetadata } from '@sentry/core'

export default (): void => {
  Sentry.init({
    dsn: 'https://96c8f6a013a8416cb3741c78317c45f6@logs.auravant.com/79',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          'localhost', 
          'http://dev.auravant.com:8080', 
          'https://auraview.auravant.com',
          'https://ag.experta.app',
          'https://auraviewpreprodtech.auravant.com', 
          'dev.auravant.com'
        ]
      }),
      new ModuleMetadata()
    ],
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    beforeSend: (event) => {
      event.tags = event.tags ?? {}
      const frames = event?.exception?.values?.[0].stacktrace?.frames ?? []
      const frame = frames.findLast(frame => frame.module_metadata?.mfe_name != null && frame.module_metadata.mfe_id_version) ?? {}
      
      if (frame.module_metadata !== undefined) {
        event.tags = {
          ...event.tags,
          mfe_name: frame.module_metadata.mfe_name,
          mfe_version: frame.module_metadata.version
        }
      }
      if (event.extra?.__serialized__ != null) {
        event.tags = {
          ...event.tags,
          mfe_name: (event.extra.__serialized__ as any).mfe_name,
          mfe_version: (event.extra.__serialized__ as any).mfe_version
        }
      }
      return event
    }
  })
}
